import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import { initLegalTransactionRelationshipSkeleton } from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import { ChildMemberSchema, IMemberChild } from '../../Members/IMemberChild';
import { IMemberParent, ParentMemberSchema } from '../../Members/IMemberParent';

export const FamilyRelationshipSchema =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.Family),
    z.literal(2).optional(),
    z.object({}),
    z.discriminatedUnion('idRelationshipRole', [
      ParentMemberSchema,
      ChildMemberSchema,
    ])
  );

export type IFamilyRelationship = Omit<
  z.infer<typeof FamilyRelationshipSchema>,
  'Members'
> & {
  Members: (IMemberParent | IMemberChild)[];
};

export function getEmptyFamilyRelationship(): IFamilyRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Family,
    Members: [],
    data: {},
  };
}
